import { useStore } from '../../store';
const { channel } = useStore();
export default {
  mounted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 有一些数据是依赖于登录状态的，所以一定要数据加载好才能进行发送
          setTimeout(() => {
            const logMessage = binding.value;
            let data = new FormData();
            data.append('activity', import.meta.env.VITE_NAME);
            data.append(
              'details',
              JSON.stringify({
                page_home: logMessage.name,
              })
            );
            data.append('project', import.meta.env.VITE_TEAM);
            data.append('channel', channel.channel);

            fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log `, {
              method: 'POST',
              body: data,
            });
            observer.unobserve(el);
          }, 5000);
        }
      });
    });

    observer.observe(el);
  },
};
